import { render, staticRenderFns } from "./BuyplayerModal.vue?vue&type=template&id=463beed1&"
import script from "./BuyplayerModal.vue?vue&type=script&lang=js&"
export * from "./BuyplayerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports